import { render } from "./TyreDetails.vue?vue&type=template&id=68ca754b&scoped=true"
import script from "./TyreDetails.vue?vue&type=script&lang=js"
export * from "./TyreDetails.vue?vue&type=script&lang=js"

import "./TyreDetails.vue?vue&type=style&index=0&id=68ca754b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ca754b"]])

export default __exports__